import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Classification } from '@vinnova/formrenderer';

@Injectable({ providedIn: 'root' })
export class ClassificationClient {
  private klassificeringUrl = environment.ansokanApiUrl + '/klassificering';

  constructor(private http: HttpClient) {}

  public getAllClassification(typeId: string): Observable<Classification[]> {
    const url = `${this.klassificeringUrl}/${typeId}`;
    return this.http.get<Classification[]>(url);
  }
}
